import React, { useState } from "react";
import { DateTime } from "luxon";
import { DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import i18n from "../../i18n";
import TimeSpan from "../../utils/time-span";
import { dateTimeToTimespan, timespanToDateTime } from "../../utils/date";

import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

const CustomTimePicker: React.FC<{
  value: TimeSpan;
  onValueChange: (newValue: TimeSpan) => void;
  label?: string;
  maxTime?: TimeSpan;
}> = ({ value, onValueChange, label, maxTime }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const changeHandler = (newDate: DateTime | null) => {
    if (newDate != null && newDate.isValid) {
      onValueChange(dateTimeToTimespan(newDate));
    }
  };

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={i18n.language}>
        <DesktopTimePicker
          label={label}
          value={timespanToDateTime(value)}
          maxTime={maxTime != null ? timespanToDateTime(maxTime) : undefined}
          minutesStep={isPopupOpen ? 5 : 1}
          closeOnSelect={false}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
          onOpen={() => setIsPopupOpen(true)}
          onClose={() => setIsPopupOpen(false)}
          onChange={changeHandler}
          format="HH:mm"
          ampmInClock={false}
          ampm={false}
          slotProps={{ textField: { variant: "standard" } }}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default CustomTimePicker;